import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { People } from '@mui/icons-material';
import { EmployeeLayout } from '@/components/Layout';
import { UserManagementPanel } from '@/components/admin';
import { apiClient } from '@/utils/api-client';

const UserManagement: React.FC = () => {
  const handleUserAction = async (userId: string, action: string) => {
    try {
      await apiClient.post(`/admin/users/${userId}/moderate`, { action });
      console.log(`User action: ${action} on user ${userId} completed successfully`);
    } catch (error) {
      console.error(`Failed to perform ${action} on user ${userId}:`, error);
    }
  };

  return (
    <EmployeeLayout>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <People sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
            User Management
          </Typography>
        </Box>

        <UserManagementPanel onUserAction={handleUserAction} />
      </Box>
    </EmployeeLayout>
  );
};

export default UserManagement;